var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h footerIOS",staticStyle:{"min-height":"0.54rem"}}),_vm._v(" "),_c('ul',{staticClass:"footer footerIOS"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:index,class:{
        footers:
          (_vm.homeIcon &&
            ((_vm.footerIndex == 0 && _vm.footerIndex + 2 == index) ||
              (_vm.footerIndex > 0 && _vm.footerIndex <= 2 && _vm.footerIndex - 1 == index) ||
              (_vm.footerIndex > 2 && _vm.footerIndex == index))) ||
          (!_vm.homeIcon && _vm.footerIndex == index)
      },on:{"click":function($event){return _vm.footerClick(index)}}},[_c('div',{staticClass:"tagsImg",class:{ homeIconTags: _vm.homeIcon && index == 2 }},[(index == 3 && _vm.cartnum > 0)?_c('i'):_vm._e(),_vm._v(" "),(
            (_vm.homeIcon &&
              ((_vm.footerIndex == 0 && _vm.footerIndex + 2 == index) ||
                (_vm.footerIndex > 0 && _vm.footerIndex <= 2 && _vm.footerIndex - 1 == index) ||
                (_vm.footerIndex > 2 && _vm.footerIndex == index))) ||
            (!_vm.homeIcon && _vm.footerIndex == index)
          )?_c('img',{class:{ homeIcon: _vm.homeIcon && index == 2 },attrs:{"src":item.changeIcon}}):_c('img',{class:{ homeIcon: _vm.homeIcon && index == 2 },attrs:{"src":item.icon}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4ecb06cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footerComp.vue
// module id = null
// module chunks = 